<template>
<v-row>
  <v-col cols="8"> {{ switchLabel }} </v-col>
  <v-switch v-model="hasPassword" hide-details >
</v-switch>
</v-row>
  <v-row v-if="displayPasswordField && hasPassword">
    <v-col cols="8">
        <v-text-field v-model="pwd" prepend-icon="mdi-lock-outline" label="Пароль" type="password" required >
        </v-text-field>
    </v-col>
    <v-col cols="4">
      <v-btn v-if="pwd" class="mt-2" @click="setPassword">
        Готово
      </v-btn>
    </v-col>
  </v-row>
  <v-divider class="mt-2 mb-2"></v-divider>

  <v-row>
  <v-col cols="12">
    <v-select label="Срок действия ссылки" v-model="selectDate"
     icon="mdi-infinity"
    :items="items" item-title="period" item-value="days" :hint="expired" persistent-hint return-object
  ></v-select>
  </v-col>
</v-row>
  <v-snackbar
    v-model="info"
      :timeout="5000"
      color="blue-grey"
      rounded="pill"
    >
  <template v-slot:activator="{ props }">
        <v-btn class="clipboard-btn" icon="mdi-clipboard" @click="copyToClipboard" color="blue-grey" rounded="pill" v-bind="props"></v-btn>
      </template>
       <strong>Ссылка скопирована</strong>
    </v-snackbar>
</template>

<script>
import Utils from '@topomatic/tap/src/utils';

export default {
    name: 'ShareDialog',
    props: {
        payload: Object,
    },
    data() {
        return {
            info: false,
            share: undefined,
            api: this.payload.api,
            file: this.payload.file,
            pwd: undefined,
            displayPasswordField: false,
            selectDate: null,
            periods: [1, 7, 30, 0],
            items: [
                { period: '1 день', days: 1 },
                { period: 'Неделя', days: 7 },
                { period: 'Месяц', days: 30 },
                { period: 'Навсегда', days: 0 },
            ],
        };
    },
    async mounted() {
        if (!this.file.share) {
            this.share = await this.api.shareFile(this.file.id, undefined, false, 0, 7);
            this.file.share = [this.share];
        } else {
            this.share = await this.api.getShareFile(this.file.share[0].id);
        }
        if (this.expired) {
            this.items.unshift({
                period: this.expired,
                days: -1,
            });
            this.selectDate = this.items[0];
        } else {
            this.selectDate = this.items[3];
        }
        this.info = false;
        this.copyToClipboard();
    },
    computed: {
        link() {
            const uri = new URL(document.location.origin);
            return `${uri.origin}?view=share&id=${this.share.id}`;
        },
        expired() {
            if (!this.share || this.selectDate?.days < 0) {
                return '';
            }
            const expired_d = (new Date(this.share.expired));
            const currentYear = new Date().getFullYear();
            if (expired_d.getFullYear() > currentYear + 2) {
                return '';
            }
            return `до ${Utils.parseDate(this.share.expired).format('DD MMM HH:mm', { locale: 'ru' })}`;
        },
        hasPassword: {
            get() {
                return this.share?.password ?? false;
            },
            async set(value) {
                if (!value && this.share.password) {
                    this.share = await this.api.updateShare(this.share.id, this.file.id, '');
                    this.share.password = value;
                    this.file.share = [this.share];
                }
                if (this.share !== undefined) {
                    this.share.password = value;
                }
                this.displayPasswordField = value;
            },
        },
        switchLabel() {
            return this.hasPassword ? 'Пароль установлен' : 'Установить пароль';
        },
    },
    watch: {
        async selectDate(value, oldValue) {
            if (oldValue) {
                const days = value.days;
                if (this.items[0].days === -1) {
                    this.items.shift();
                }
                this.share = await this.api.updateShare(this.share.id, this.file.id, undefined, days * 60 * 60 * 24);
                this.file.share = [this.share];
            }
        },
    },
    methods: {
        async setPassword() {
            this.displayPasswordField = false;
            this.share = await this.api.updateShare(this.share.id, this.file.id, this.pwd);
            this.file.share = [this.share];
        },
        dates(day_num) {
            if (day_num === 0 || !this.share) {
                return 'Навсегда';
            }
            const today = new Date();
            const options = {
                month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric',
            };
            today.setDate(today.getDate() + day_num);
            return `до ${today.toLocaleString('ru', options)}`;
        },
        copyToClipboard() {
            navigator.clipboard?.writeText(this.link);
            this.info = true;
        },
    },
};
</script>

<style lang="css" scoped>
.clipboard-btn {
    position: absolute;
    top: calc(100% - 60px);
}
</style>
